module.exports = __webpack_public_path__ + "static/media/DR_bg.8c50e133.bmp";